import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Routing from './routes/index.route';
import { UserProvider } from './Context/User.context';
// import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <UserProvider>
    <Routing />
    <ToastContainer position="top-center" autoClose={5000} newestOnTop={false} closeOnClick rtl={false} />
  </UserProvider>,
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//
// Service worker volontairement désactivé : il servait les anciens bundles
// depuis son cache après chaque mise à jour (Ctrl+F5 nécessaire).
// `unregister()` supprime aussi un service worker déjà installé.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
